export const en = {
    search : {
    placeholder: 'Search...'
},
    typetitle : {
    type: 'Type'
},
    pokecardname : {
    name: 'Name'
},
    pokecardevolutions : {
    evolutions: 'Evolutions'
},
    pokecarmoves : {
    moves: 'Moves'
},
};